export enum XContestTypes {
  JOIN_XCONTEST_CALL = 'JOIN_XCONTEST_CALL',
  JOIN_XCONTEST_SUCCESS = 'JOIN_XCONTEST_SUCCESS',

  CONTEST_FORM_DATA = 'CONTEST_FORM_DATA',
  CLEAR_CONTEST_DATA = 'CLEAR_CONTEST_DATA',
  UPDATE_JOIN_CONTEST_FORM_CALL = 'UPDATE_JOIN_CONTEST_FORM_CALL',
  CLEAR_JOIN_CONTEST_FORM_CALL = 'CLEAR_JOIN_CONTEST_FORM_CALL',

  GET_ALL_XCONTESTS_CALL = 'GET_ALL_XCONTESTS_CALL',
  GET_ALL_XCONTESTS_SUCCESS = 'GET_ALL_XCONTESTS_SUCCESS',

  GET_USER_XCONTESTS_CALL = 'GET_USER_XCONTESTS_CALL',
  GET_USER_XCONTESTS_SUCCESS = 'GET_USER_XCONTESTS_SUCCESS',

  GET_USER_XCONTEST_ACTIVITIES_CALL = 'GET_USER_XCONTEST_ACTIVITIES_CALL',
  GET_USER_XCONTEST_ACTIVITIES_SUCCESS = 'GET_USER_XCONTEST_ACTIVITIES_SUCCESS',

  GET_USER_XCONTEST_LEADERBOARD_CALL = 'GET_USER_XCONTEST_LEADERBOARD_CALL',
  GET_USER_XCONTEST_LEADERBOARD_SUCCESS = 'GET_USER_XCONTEST_LEADERBOARD_SUCCESS',

  DELETE_USER_XCONTEST_CALL = 'DELETE_USER_XCONTEST_CALL',
  DELETE_USER_XCONTEST_SUCCESS = 'DELETE_USER_XCONTEST_SUCCESS',
}

export interface xContestState {
  all: []
  userContests: []
  activities: []
  leaderboard: []
  joinForm: JoinContestPayload
}

export interface JoinContestPayload {
  contest_id: string
  saving_type: string
  device: 'mobile' | 'web'
  saving_frequency: string
  start_date: string
  maturity_date: string
}
